module.exports = __webpack_public_path__ + "img/BENEFICIOS.eb49ce19.jpg";